import type { SegmentProps } from './SegmentedControls.types'
import cn from 'classnames'
import * as React from 'react'
import { wrapTextChildrenWithTypography } from '../../utils/wrapChildrenWithTypography'
import styles from './Segment.module.css'

export function Segment({ active, children, className, onClick, value, ...attributes }: SegmentProps) {
  const onClickHandler = () => {
    onClick?.(value)
  }

  return (
    <button
      className={cn(styles.segment, { [styles.active]: active }, className)}
      onClick={onClickHandler}
      type="button"
      {...attributes}
    >
      <span className={styles.content}>
        {wrapTextChildrenWithTypography(children, styles.typography)}
      </span>
    </button>
  )
}
